import {Company} from '../state/types/Company';


export const calculateBGScore = (company: Company, highestVotes: number, activeVersion: number = 5): number => {
    return (!company.voting?.[activeVersion]?.votes || !company.voting?.[activeVersion]?.votes || 0) ? 0 :
        Number((Math.pow(
            company.voting?.[activeVersion]?.sum / company.voting?.[activeVersion]?.votes,
            ((((company.voting?.[activeVersion]?.votes) / highestVotes) ** 0.4) * 0.7) + 0.3)
        ).toFixed(1));
};

export const getHighestVotes = (companyList: Company[], activeVersion: number = 5): number => {
    return companyList.reduce((max, row) => {
        const votes = row.voting?.[activeVersion]?.votes || 0;
        return votes > max ? votes : max;
    }, 0);
};
